const IMSMock = {
  isSignedInUser: () => true,
  accessToken: process.env.IMS_TOKEN,
  getAccessToken: () => ({ token: process.env.IMS_TOKEN }),
  getProfile: async () => ({
    email: process.env.IMS_EMAIL,
    displayName: process.env.IMS_DISPLAY_NAME,
  }),
};

/* used for dev on localhost without the container */
const mockedIMSWrapper = {
  initialized: true,
  ...IMSMock,
};

export default window.adobeIMS ? window.adobeIMS : mockedIMSWrapper;
